import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTick = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 8,
	viewBox: "0 0 10 8",
	stroke: "green",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Success" }), /* @__PURE__ */ _jsx("path", {
		d: "M9 1L3.5 6.5L1 4",
		stroke: "current",
		strokeWidth: 1.6666,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgTick;
